import React, { useState, useEffect, useMemo } from 'react';
import { packagesAPI } from '../services/api';
import PackageCard from './PackageCard';

const PACKAGE_FILTERS = ['All', 'Adventure', 'Family', 'Honeymoon', 'Group'];

const Packages = () => {
  const [packagesData, setPackagesData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('All');

  useEffect(() => {
    fetchPackages();
  }, []);

  const fetchPackages = async () => {
    try {
      const response = await packagesAPI.getAll();
      console.log('Packages API Response:', response);
      console.log('Packages Data:', response.data);
      // Handle both array and object response
      const packages = Array.isArray(response.data) ? response.data : (response.data?.packages || []);
      setPackagesData(packages);
      console.log('Set packages data:', packages);
    } catch (error) {
      console.error('Error fetching packages:', error);
      // Show user-friendly error message
      if (error.code === 'ERR_NETWORK' || error.message === 'Network Error') {
        console.error('CORS or Network Error: Backend server may not be allowing requests from this origin');
        console.error('Please check backend CORS configuration at https://api.goadeals.in');
      }
      setPackagesData([]);
    } finally {
      setLoading(false);
    }
  };

  const filteredPackages = useMemo(() => {
    if (filter === 'All') return packagesData;
    return packagesData.filter((p) =>
      (p.category || '').toLowerCase().includes(filter.toLowerCase())
    );
  }, [packagesData, filter]);

  if (loading) {
    return (
      <section className="section gd-packages-list" id="packages">
        <div className="container">
          <div style={{ textAlign: 'center', padding: '50px' }}>
            Loading packages...
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="section gd-packages-list" id="packages">
      <div className="container">
        <div className="gd-section-top">
          <div>
            <p className="gd-kicker">Goa Packages</p>
            <h2 className="gd-heading">Explore all Goa tour packages</h2>
          </div>
        </div>

        <div className="gd-filters cat-pills" role="tablist" aria-label="Package filters">
          {PACKAGE_FILTERS.map((f) => (
            <button
              key={f}
              type="button"
              role="tab"
              aria-selected={filter === f}
              className={`gd-filter ${filter === f ? 'is-active' : ''}`}
              onClick={() => setFilter(f)}
            >
              {f}
            </button>
          ))}
        </div>

        <div className="cat-grid">
          {filteredPackages.length === 0 ? (
            <p className="gd-empty">No packages available at the moment.</p>
          ) : (
            filteredPackages.map((pkg) => <PackageCard key={pkg._id || pkg.id} pkg={pkg} />)
          )}
        </div>
      </div>
    </section>
  );
};

export default Packages;